export const initProfileForm = () => {
    // VARS
    const formSelector = '[data-profile-form]';
    const form = document.querySelector(formSelector);
    if (!form) return;
    const profileInput = form.querySelector('[data-profile-input]');
    const profileInputWrap = form.querySelector('[data-profile-input-wrap]');
    const error = form.querySelector('[data-field-error]');
    const profileButton = form.querySelector('[data-profile-button]');
    const profileButtonUsername = form.querySelector('[data-profile-button-username]');
    const classLinkIcon = 'profile-input-wrap--link';
    const instagramDomain1 = 'https://instagram.com/';
    const instagramDomain2 = 'https://www.instagram.com/';
    const minLengthUserName = 1;
    const maxLengthUserName = 50;
    let isValidForm = true;

    // INITS
    profileInput.value = '';

    // EVENTS
    form.addEventListener('submit', handleOnSubmit, false);

    profileInput.addEventListener('input', handleOnInput, false);
    profileInput.addEventListener('focus', handleOnFocus, false);
    profileInput.addEventListener('change', handleOnChange, false);

    // HANDLERS
    function handleOnSubmit(event) {
        validateProfileInput();

        if (!isValidForm) {
            event.preventDefault();
            isValidForm = true;
        }
    }

    function handleOnInput() {
        const value = this.value.trim();

        toggleIcon(value);
        setValueToButton(value);
    }

    function handleOnChange() {
        const value = this.value.trim();

        toggleIcon(value);
    }

    function handleOnFocus() {
        hideProfileInputError();
    }

    // FUNCTIONS

    function toggleIcon(value) {
        value.indexOf('https') === 0
            ? profileInputWrap.classList.add(classLinkIcon)
            : profileInputWrap.classList.remove(classLinkIcon);
    }

    function validateProfileInput() {
        const inputValue = profileInput.value.trim();

        if (inputValue.length <= minLengthUserName) {
            isValidForm = false;
        }

        if (inputValue.indexOf('https') !== -1) {
            const accountLink = clearAccountLink(inputValue);

            if (accountLink.length <= instagramDomain1.length + minLengthUserName) {
                isValidForm = false;
            }

            if (accountLink.length >= instagramDomain1.length + maxLengthUserName) {
                isValidForm = false;
            }

            if (accountLink.indexOf(instagramDomain1) === -1 || accountLink.indexOf(instagramDomain1) !== 0) {
                isValidForm = false;
            }
        } else if (inputValue.length > maxLengthUserName) {
            isValidForm = false;
        }

        if (!isValidForm) {
            showProfileInputError();
        }
    }

    function showProfileInputError() {
        profileInputWrap.classList.add('has-error');
        error.classList.add('is-error');
    }

    function hideProfileInputError() {
        profileInputWrap.classList.remove('has-error');
        error.classList.remove('is-error');
    }

    function setValueToButton(value) {
        let currentValue = value;

        if (currentValue.indexOf(instagramDomain1) === 0 || currentValue.indexOf(instagramDomain2) === 0) {
            currentValue = clearAccountLink(value);
            currentValue = currentValue.replace(instagramDomain1, '');
        }

        if (currentValue.indexOf('@') === 0) {
            currentValue = currentValue.substring(1);
        }

        if (currentValue.indexOf('/') >= 0) {
            currentValue = currentValue.replaceAll('/', '');
        }

        profileButtonUsername.textContent = currentValue;
    }

    function clearAccountLink(link) {
        let clearedLink = link;

        if (clearedLink.indexOf('https://www.') !== -1) {
            clearedLink = clearedLink.replace('www.', '');
        }

        const accountFullLink = new URL(clearedLink);
        return accountFullLink.origin + accountFullLink.pathname;
    }
};
